import { render, staticRenderFns } from "./IconTriangleExclamation.vue?vue&type=template&id=0443e4a6&functional=true&"
import script from "./IconTriangleExclamation.vue?vue&type=script&lang=js&"
export * from "./IconTriangleExclamation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports